<template>
    <!-- 管理员- 课程统计 -->
    <div class="course wrapper">
        <proTitle></proTitle>
        <div class="switch">
            <div class="switch-btn-warpper" :class="{'active':activeSwitch == index}"
                v-for="(item,index) in ['同步课程','异步课程']" :key="index" @click="switchType(index)">
                <button class="csp switch-btn">
                    {{item}}
                </button>
            </div>
        </div>
        <el-form :inline="true" :model="formInline" class="demo-form-inline flex-align-between">
            <div class="formInline-left">
                <el-date-picker size="mini" v-model="formInline.datetimerange" type="datetimerange"
                    start-placeholder="开始日期" range-separator="至" end-placeholder="结束日期" prefix-icon="el-icon-date"
                    @change="filterChange" value-format="yyyy-MM-dd HH:mm:ss" :editable="false" class="date-picker">
                </el-date-picker>
            </div>
            <div class="formInline-right flex-align-between">
                <el-input size="mini" v-model="formInline.search" placeholder="课程或课节名称" suffix-icon="el-icon-search"
                    @input="filterChange">
                </el-input>
            </div>
            <div class="download-inline">
                <span class="export-btn csp" style="margin-right:10px" @click="exportFile">
                    <i class="export-icon"></i>导出</span>
                <span class="export-btn csp" @click="refreshData">
                    <i class="el-icon-refresh"></i>刷新数据</span>
            </div>
        </el-form>
        <div class="table_section">
            <el-table :data="tableData" border style="width: 100%">
                <!--  <span class="num" v-html="currentPage>1?(pagesize*(currentPage-1))+index+1:index+1"></span> -->
                <el-table-column prop="number" label="序号" width="80" align="center" type="index" :index="indexMethod">
                </el-table-column>
                <el-table-column prop="courseName" label="课程名称" align="center" width="200" show-overflow-tooltip>
                </el-table-column>
                <el-table-column prop="lessonName" label="课节名称" align="center" width="200" show-overflow-tooltip>
                </el-table-column>
                <el-table-column :prop="!activeSwitch?'attendanceCount':'learnCount'"
                    :label="!activeSwitch?'出勤人数\n（单位：个）':'学习人数\n（单位：个）'" width="130" align="center">
                    <template slot-scope="scope">
                        <span v-if="!activeSwitch">{{scope.row.attendanceCount || 0}}</span>
                        <span v-else>{{scope.row.learnCount || 0}}</span>
                    </template>
                </el-table-column>
                <el-table-column prop="liveTime" :label="'直播学习总时长\n(单位：秒)'" width="130" align="center"
                    v-if="!activeSwitch">
                    <template slot-scope="scope">
                        {{parseInt(scope.row.liveTime)}}
                    </template>
                </el-table-column>
                <el-table-column prop="recordTime" :label="'观看回放总时长\n（单位：秒）'" width="130" align="center"
                    v-if="!activeSwitch">
                    <template slot-scope="scope">
                        {{parseInt(scope.row.recordTime)}}
                    </template>
                </el-table-column>
                <el-table-column prop="recordTime" :label="'学习总时长\n(单位：秒)'" align="center" v-if="activeSwitch">
                    <template slot-scope="scope">
                        {{parseInt(scope.row.recordTime)}}
                    </template>
                </el-table-column>
                <el-table-column fixed="right" label="操作" align="center" width="120">
                    <template slot-scope="scope">
                        <el-button @click="toDetail(scope.row)" type="text" size="small">学员详情
                        </el-button>
                    </template>
                </el-table-column>
            </el-table>
            <pagination :total="pages.total" :page.sync="pages.currentPage" :limit.sync="pages.pageSize"
                :pageSizes="[10,20,30]" @pagination="handlePageChange">
            </pagination>
        </div>
    </div>

</template>

<script>
    import upload from './components/upload-file.vue';

    export default {
        components: {
            upload,
        },
        data() {
            return {
                tableData: [],
                pages: { //分页
                    currentPage: 1,
                    pageSize: 10,
                    total: 0,
                },
                formInline: {
                    datetimerange: '',
                    search: '',
                },
                courseType: 0,
                activeSwitch: 0,
                loadingInstance: ''
            };
        },
        methods: {
            indexMethod(index) {
                return this.pages.currentPage > 1 ?
                    (this.pages.pageSize * (this.pages.currentPage - 1)) + index + 1 :
                    index + 1
            },
            // 翻页
            handlePageChange(data) {
                this.pages.currentPage = data.pageIndex
                this.pages.pageSize = data.pageSize
                this.getCourseStudyInfo();
            },
            toDetail(row) {
                this.$router.push({
                    path: `/coursePersonnel/${row.lessonId}`,
                    query: {
                        type: this.courseType,
                        breadNumber: 4,

                    }
                })

            },
            filterChange() {
                this.pages.currentPage = 1;
                this.getCourseStudyInfo();
            },
            async exportFile() {
                // let params = {
                //     // projectId: sessionStorage.getItem('projectID'),
                //     projectId: this.$store.state.user.currentProject.id,
                //     lessonsPattern: this.courseType
                // }
                // let resData = await this.$Api.Project.exportCourseStatisticInfo(params)
                // console.log(resData);
                this.$message.info('正在导出...')
                let id = this.$store.state.user.currentProject.id
                window.location.href =
                    `${this.commonbaseURL}/score/projectHome/getCourseStudy/export?projectId=${id}&lessonsPattern=${this.courseType}`;
            },
            refreshData() {
                this.formInline.datetimerange = '';
                this.formInline.search = '';
                this.pages.currentPage = 1;
                this.loadingInstance = this.$loading({
                    // fullscreen:false,
                    lock: true,
                    text: '数据刷新中...',
                    spinner: 'el-icon-loading',
                });
                let data = {
                    projectId: this.$store.state.user.currentProject.id
                }
                this.$Api.Project.sendRefresh(data)
                    .then(res => {
                        console.log('发送刷新成功', res);
                        this.getCourseStudyInfo();
                    })
                    .catch(err => {
                        console.log('发送刷新失败', err)
                    })
            },
            switchType(index) {
                this.activeSwitch = index;
                this.courseType = index;
                Vue.set(this.formInline, 'datetimerange', '');
                Vue.set(this.formInline, 'search', '');
                this.pages.currentPage = 1;
                this.getCourseStudyInfo();
            },
            // 获取周报列表
            async getCourseStudyInfo() {
                let pramas = {
                    page: this.pages.currentPage,
                    limit: this.pages.pageSize,
                    projectId: this.$store.state.user.currentProject.id,
                    lessonsPattern: this.courseType,
                }
                pramas.keys = this.formInline.search ? this.formInline.search : null;
                pramas.startTime = this.formInline.datetimerange ? this.formInline.datetimerange[0] : null;
                pramas.finishTime = this.formInline.datetimerange ? this.formInline.datetimerange[1] : null;
                let resData = await this.$Api.Project.getCourseStudyInfo(pramas);
                // console.log(resData.data.records);
                this.tableData = resData.data.records
                this.pages.total = resData.data.total
                if (this.loadingInstance) {
                    this.loadingInstance.close()
                }
            },
            // 查询刷新状态
            async checkRefresh() {
                let data = {
                    projectId: this.$store.state.user.currentProject.id
                }
                let resData = await this.$Api.Project.checkRefresh(data)
                console.log('查询刷新状态', resData);
                if (resData.msg = "未刷新或刷新完成") {
                    console.log('刷新完成关闭loading');
                    if (this.loadingInstance) {
                        this.loadingInstance.close()
                    }
                } else {
                    console.log('正在刷新显示loading');
                    this.loadingInstance = this.$loading({
                        lock: true,
                        text: '数据刷新中...',
                        spinner: 'el-icon-loading',
                    });
                }
            }
        },
        mounted() {
            this.getCourseStudyInfo();
            this.checkRefresh()
        },
    }
</script>

<style lang="less" scoped>
    @import "../manage/less/table.less";

    .course {
        padding: 20px 25px;
        box-sizing: border-box;

        .switch {
            .switch-btn-warpper {
                height: 42px;
                display: inline-block;
                margin-right: 10px;
            }

            .switch-btn {
                padding: 0 31px;
                font-size: 15px;
                line-height: 36px;
            }

            .active {
                background-image: url("~@/assets/images/admin/course-switch.png");
                background-size: 100% 100%;

                .switch-btn {
                    color: #508ef9;
                }
            }
        }

        .demo-form-inline {
            margin: 15px 0;

            .date-picker {
                width: 320px;
            }

            @media screen and (min-width:1250px) {
                margin: 20px 0;

                .date-picker {
                    width: 400px;
                }
            }
        }

        .download-inline {
            .export-btn {
                color: #595959;
            }

            .export-icon {
                display: inline-block;
                background-image: url("~@/assets/images/admin/export.png");
                background-size: 100% 100%;
                width: 17px;
                height: 16px;
                margin-right: 8px;
                vertical-align: -2px;
            }
        }


        .table_section {
            /deep/.el-table th {
                &>.cell {
                    white-space: pre-line;
                }
            }
        }

    }
</style>